import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { RouteParamsRequest } from '#models';
import type { ChatroomDataObject } from '#models/services';
import { routes } from '#routes';

export type DeleteMemberFromChatroomRouteParameters =
  paths['/chatrooms/{chatroomId}/members/{memberId}']['delete']['parameters']['path'];

export const deleteMemberFromChatroom = async ({
  routeParams: { chatroomId, memberId },
}: RouteParamsRequest<DeleteMemberFromChatroomRouteParameters>) =>
  getNodeApiAxiosInstance().delete<ChatroomDataObject, AxiosResponse<ChatroomDataObject>>(
    routes.chatrooms.members.remove(chatroomId, memberId),
  );
